export function approvalTypeLabel(approvalType) {
    let typeLabel = approvalType;
    if(approvalType == 'AUTO') {
        typeLabel = 'AUTOMATIC APPROVAL'
    } else if(approvalType == 'ADMINISTRATOR') {
        typeLabel = 'SUPER ADMINISTRATOR'
    } else if(approvalType == 'APPROVAL_MANAGER') {
        typeLabel = 'APPROVER'
    } else if(approvalType == 'APPROVAL_MANAGER_AND_ADMINISTRATOR_SEQUENTIAL') {
        typeLabel = 'SEQUENTIAL APPROVER AND SUPER ADMINISTRATOR';
    } else if(approvalType == 'APPROVAL_MANAGER_AND_ADMINISTRATOR') {
        typeLabel = 'PARALLEL APPROVER AND SUPER ADMINISTRATOR';
    } else if(approvalType == 'APPROVAL_MANAGER_OR_ADMINISTRATOR') {
        typeLabel = 'APPROVER OR SUPER ADMINISTRATOR';
    }
    return typeLabel;
}

export function requestTypeLabel(requestType) {
    let typeLabel = requestType;
    if(requestType == 'HELPDESK') {
        typeLabel = 'HELPDESK'
    } else if(requestType == 'APP_ACCESS') {
        typeLabel = 'APP ACCESS'
    } else if(requestType == 'APPROVAL_FORM') {
        typeLabel = 'APPROVAL FORM'
    } 
    return typeLabel;
}

export function prepareWaitingApprovals(requestDto) {
    let result = [];
    if(requestDto.waitingManagerApprovals > 0) {
        result.push('APPROVER');
    }
    if(requestDto.waitingAdminApprovals > 0) {
        result.push('SUPER ADMINISTRATOR');
    }
    return result;
}

export function isApproveAvailableForAdmin(request) {
    return (request.status == 'PENDING' && (request.type == 'HELPDESK' || request.type == 'APPROVAL_FORM' || request.waitingAdminApprovals > 0 && 
                (request.waitingManagerApprovals <= 0 || 
                    request.approvalType != 'APPROVAL_MANAGER_AND_ADMINISTRATOR_SEQUENTIAL')));
}

export function isApproveAvailableForApprovalManager(request) {
    return request.type == 'APP_ACCESS' && request.status == 'PENDING' && request.waitingManagerApprovals > 0;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/request-center.functions.js